export default {
  confirm: {
    id: 'bo_sellers-orders-components-orders_table-actions-confirm',
    defaultMessage: 'Confirm',
  },
  confirmOrderLine: {
    id: 'bo_sellers-orders-components-orders_table-actions-confirm_order_line',
    defaultMessage: 'Confirm #{orderLineId}',
  },
  addOrderLineIMEI: {
    id: 'bo_sellers-orders-components-orders_table-actions-add_order_line_imei',
    defaultMessage: 'Add IMEI for orderline {orderLineId}',
  },
  addIMEI: {
    id: 'bo_sellers-orders-components-orders_table-actions-add_imei',
    defaultMessage: 'Add IMEI',
  },
  aboutLine: {
    id: 'bo_sellers-orders-components-orders_table-actions-about_line_item',
    defaultMessage: 'about line item {orderLineId}',
  },
} as const
